export const SocialData = [
  {
    platform: "Whatsapp",
    icon: require("../../assets/icons/whatsapp.png"),
    link: "https://wa.me/qr/G5XI65HRSJYEO1",
  },
  {
    platform: "Github",
    icon: require("../../assets/icons/github.png"),
    link: "https://github.com/Efe-Roy",
  },
];